import React, { useContext, useState } from 'react'
import Card from "../../../common/card/Card"
import Notice from "../../../common/card/Notice"
import { TeamContext } from "../MenuTabs/MenuTabs"
import { LicenseTableProvider } from './context/LicenseTableContext'
import Licenses from './Licenses/Licenses'
import LicensePresets from './LicensePresets/LicensePresets'
import Button from '../../../common/button/Button'

const LicenseNav = ({ teamType, refetchTeamData }) => {

    const tabs = {
        licenses: {
          key: 'licenses',
          value: 'Licenses' 
        },
        licensePresets: {
          key: 'license-presets',
          value: 'License Presets'
        }
    }

    const [ currentTab, setCurrentTab ] = useState(tabs.licenses.key)
  const { teamData } = useContext(TeamContext)

  const renderComponent = () => {
    
    switch( currentTab ){
      case tabs.licenses.key:
        return (
          <LicenseTableProvider>
            <Licenses teamType={teamType}/>
          </LicenseTableProvider>
        )
      case tabs.licensePresets.key:
        return (
          <LicenseTableProvider>
            <LicensePresets refetchTeamData={ refetchTeamData }/>
          </LicenseTableProvider>
        )
      default:
        return (
          <Notice theme='destructive'> 
            <strong>Permission denied</strong> 
          </Notice>
        )
    }
  }

  return (
    <>
      <Card>
        <div className='msync-card__header'>
            <ul className='msync-card__navigation msync-table-links'>
              {
                tabs && Object.keys(tabs).map((item) => {
                  const items = tabs[item]
                  return(
                    <li>
                      <Button
                        className={`msync-button--is-style-link${currentTab === items.key ? ' active' : ' msync-button--is-theme-secondary'}`} 
                        onClick={() => setCurrentTab(items.key)}
                      >
                        <span>{items.value}</span>
                      </Button>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        <div className='msync-card__body msync-card__body--has-table'>
          { renderComponent() }
        </div>
      </Card>
    </>
  )
}

export default LicenseNav
